import { CompetitionFlowService } from './../../../services/competition-flow.service';
import { Component, OnInit, Renderer2 } from '@angular/core';
import { LoadingController, NavController, NavParams } from '@ionic/angular';
import { Preference } from 'src/storage/preference';
import * as global from 'src/globals';
import { adjustViewZIndex } from 'src/globals';
import { CompetitionInfo } from 'src/data/competition-data';
import { PlayerHomeInfo } from 'src/data/player-data';
import { CompetitionService } from 'src/providers/competition-service/competition-service';
import { Observable, of } from 'rxjs';
import { PlayerHomeActions } from 'src/redux/player-home';
import { GameroundScoringPage } from '../../gameround-scoring/gameround-scoring.page';
import { CurrentScorecardActions } from 'src/redux/scorecard';
import {
  PlayerInfo,
  PlainScoreCard,
  CompetitionMatch,
  CompetitionMatchParticipant,
  CompetitionData,
} from 'src/data/mygolf.data';
import { ScorecardService } from 'src/providers/scorecard-service/scorecard-service';
import { NavigationExtras, Router } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { Location } from '@angular/common';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { mygolfUtils } from 'src/custom/mygolf2u-utils';

@Component({
  selector: 'app-competition-scoring',
  templateUrl: './competition-scoring.page.html',
  styleUrls: ['./competition-scoring.page.scss'],
})
export class CompetitionScoringPage implements OnInit {
  homeInfo: Observable<PlayerHomeInfo>;
  activeCompetitions: any; // Observable < Array < CompetitionInfo >> ;
  fromMultiple: boolean = false;

  dataExtras;
  player: PlayerInfo;

  constructor(
    private nav: NavController,
    private playerHomeActions: PlayerHomeActions,
    private navParams: NavParams,
    private competitionService: CompetitionService,
    private currentScorecardActions: CurrentScorecardActions,
    private scorecardService: ScorecardService,
    private loadingCtl: LoadingController,
    private router: Router,
    private location: Location,
    private flightService: ClubFlightService,
    private competitionFlowService: CompetitionFlowService,
    private mg2uUtil: mygolfUtils
  ) {
    this.homeInfo = navParams.get('homeInfo');

    this.dataExtras = this.router.getCurrentNavigation().extras.state;
    console.debug('competition scoring selection : ', this.router.getCurrentNavigation().extras);
    if (this.dataExtras) {
      this.homeInfo = of(this.dataExtras.homeInfo);
      this.fromMultiple = this.dataExtras.fromMultiple;
      // if(this.homeInfo && this.homeInfo.compsActiveToday) {
      //   this.activeCompetitions = this.homeInfo.compsActiveToday;
      // }
      this.activeCompetitions = this.homeInfo
        .pipe(map(homeInfo => homeInfo.compsActiveToday))
        .pipe(filter(Boolean));
      this.player = this.dataExtras?.player;
    }

    // this.homeInfo
    // .subscribe((homeInfo: PlayerHomeInfo) => {
    //   console.debug("competition scoring selection : ", homeInfo);
    //   // this.activeCompetitions = homeInfo.compsActiveToday;
    // });

    console.debug('competition scoring selection : ', this.homeInfo, this.fromMultiple);
  }

  ngOnInit() {}

  async onSelect(comp: CompetitionInfo) {
    if (1) {
      this.onClickCompsActive(comp);
      return;
    }
    let _continue: boolean = true;
    if (0) {
      let _continue: boolean = true;
      await this.checkWhetherCompMatch(comp).then(async (cont: any) => {
        _continue = cont;
        console.debug('check whether comp match', cont, _continue);
        if (_continue) {
          if (this.fromMultiple) {
            let loader = await this.loadingCtl.create({
              message: 'Getting scorecard. Please wait...',
              // dismissOnPageChange: true,
              duration: 3000,
            });
            this.playerHomeActions.selectCompetionForScoring(comp.competitionId);
            let _player: PlayerInfo;
            this.homeInfo.pipe(take(1)).subscribe((a: any) => {
              _player = a;
            });
            // this.competitionService.getCompetitionInfo(comp.competitionId)
            //                     .subscribe((comp: CompetitionInfo) => {
            //                         // loader.dismiss().then(() => {
            //                             this.currentScorecardActions.setScoringPlayer(_player.playerId);
            //                             this.nav.push(GameRoundScoringPage, {
            //                                 scorecard    : scorecard,
            //                                 competition  : comp,
            //                                 currentPlayer: player
            //                             })
            //                         // });
            //                     }, (error) => {
            //                         // loader.dismiss();
            //                     });
            loader.present().then(() => {
              this.playerHomeActions.getCompetitionScoring(
                comp.competitionId,
                _player.playerId,
                loader
              );
              let getScorecard = setInterval(() => {
                this.scorecardService
                  .getCurrentScorecard()
                  .subscribe((scorecard: PlainScoreCard) => {
                    if (scorecard.competitionId === comp.competitionId) {
                      clearInterval(getScorecard);
                      this.competitionService.getCompetitionInfo(comp.competitionId).subscribe(
                        (comp: CompetitionInfo) => {
                          // loader.dismiss().then(() => {
                          this.currentScorecardActions.setScoringPlayer(_player.playerId);

                          let navigationExtras: NavigationExtras = {
                            state: {
                              scorecard: scorecard,
                              competition: comp,
                              currentPlayer: _player,
                            },
                          };
                          this.router.navigate(['gameround-scoring'], navigationExtras);

                          // this.nav.push(GameRoundScoringPage, {
                          //     scorecard    : scorecard,
                          //     competition  : comp,
                          //     currentPlayer: _player
                          // })
                        },
                        error => {
                          if (loader) loader.dismiss();
                          // clearInterval(getScorecard);
                        },
                        () => {}
                      );
                    }
                  });
              }, 1000);
            });
          } else {
            this.playerHomeActions.selectCompetionForScoring(comp.competitionId);
            this.router.navigate(['tabs/player-home']);
            // this.nav.popToRoot();
          }
        }
      });

      // // await this.homeInfo.pipe(filter(Boolean)).subscribe((a: PlayerHomeInfo) => {
      //   let _compId = comp?.competitionId;
      //   // if(a?.compsActiveToday?.length === 1) _compId = a?.compsActiveToday[0]?.competitionId
      //   this.getCompetitionData(Number(_compId))
      //   .then((compData: CompetitionData)=>{
      //     console.debug("get comp data ", compData, compData?.addlSettings, compData?.teamEvent, compData?.matchPlay)
      //     if(!compData?.addlSettings?.matchPlayDetailedScoring) {
      //       if(compData?.teamEvent && compData?.matchPlay) {
      //         this.getCompMatches(compData?.id)
      //         .then((playerMatches: Array<CompetitionMatch>)=>{
      //           if(playerMatches?.length) {
      //             this.goMatchplayMatches(compData, playerMatches);
      //           }
      //         })
      //         return;
      //       }
      //       _continue = false;
      //     }
      //     else _continue = true;
      //   }).catch((error)=>{
      //     _continue = true
      //   })

      // // });

      if (!_continue) return;
    }
  }

  backRouting() {
    this.location.back();
  }

  goMatchplayMatches(compData, playerMatches) {
    let navigationExtras: NavigationExtras = {
      state: {
        // scorecard: scorecard,
        // competition: this.competition,
        compData: compData,
        playerMatch: playerMatches[0],

        // compId: this.compId,
        // currentPlayer: _player,
        // editingScorecard:
        //   _isScorer && _isScorer.length > 0
        //    ?true
        //     : false,
      },
    };
    this.router.navigate(['matchplay-scoring'], navigationExtras);
  }

  playerMatches: Array<CompetitionMatch>;
  getCompMatches(compId: number) {
    return new Promise((resolve, reject) => {
      let _player: PlayerInfo = this.player;
      this.flightService.getCompMatches(compId, 1).subscribe(
        (compMatches: Array<CompetitionMatch>) => {
          console.debug('get comp matches', compMatches);

          let _currentPlayerMatches = compMatches?.filter((cm: CompetitionMatch) => {
            return (
              cm?.participants?.some((p: CompetitionMatchParticipant) => {
                return p?.player?.id === _player?.playerId;
              }) &&
              (cm?.status === 'InProgress' ||
                cm?.status === 'Pending' ||
                cm?.status === 'Completed')
            );
          });
          if (_currentPlayerMatches?.length > 0)
            //this.playerMatches = _currentPlayerMatches;
            this.playerMatches = _currentPlayerMatches
              ?.filter((pm: CompetitionMatch) => {
                return pm?.status !== 'Abandoned' && pm?.status !== 'Submitted';
              })
              .sort((a: CompetitionMatch, b: CompetitionMatch) => {
                if (a?.status === 'Completed' && b?.status === 'Pending') return -1;
                else if (a?.status === 'Pending' && b?.status === 'Completed') return 1;
                else if (a?.status === 'InProgress' && b?.status === 'Pending') return -1;
                else if (a?.status === 'Pending' && b?.status === 'InProgress') return 1;
                else {
                  if (a?.startTime < b?.startTime) return -1;
                  else if (a?.startTime > b?.startTime) return 1;
                  else return 0;
                }
              });
          console.debug(
            'get comp matches - current player ',
            compMatches,
            _player,
            _currentPlayerMatches,
            this.playerMatches
          );
          resolve(this.playerMatches);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getCompetitionData(compId: number) {
    return new Promise((resolve, reject) => {
      if (!compId) reject(true);
      this.flightService.getCompetitionDetails(compId).subscribe(
        compData => {
          resolve(compData);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  checkWhetherCompMatch(comp) {
    return new Promise((resolve, reject) => {
      let _continue: boolean = true;
      let _compId = comp?.competitionId;
      // if(a?.compsActiveToday?.length === 1) _compId = a?.compsActiveToday[0]?.competitionId
      this.getCompetitionData(Number(_compId))
        .then((compData: CompetitionData) => {
          console.debug(
            'get comp data ',
            compData,
            compData?.addlSettings,
            compData?.teamEvent,
            compData?.matchPlay
          );
          if (!compData?.addlSettings?.matchPlayDetailedScoring) {
            if (compData?.teamEvent && compData?.matchPlay) {
              this.getCompMatches(compData?.id).then((playerMatches: Array<CompetitionMatch>) => {
                if (playerMatches?.length) {
                  this.goMatchplayMatches(compData, playerMatches);
                } else resolve(true);
              });
            } else resolve(true);
          } else resolve(true);
        })
        .catch(error => {
          resolve(true);
        });
    });
  }

  async onClickCompsActive(competition) {
    // Use CompetitionFlowService to handle the flow:
    // 1. Check if matchplay → go to matchplay-scoring
    // 2. Check if compAllScores → go to scramble-scoring
    // 3. If all fails, open normal scoring (gameround-scoring)

    const _compId = competition.competitionId;
    let _continueMatchPlay: boolean = true;
    let _continueScramble: boolean = true;

    // Check if it's matchplay
    await this.competitionFlowService
      .checkWhetherCompMatch(competition, false, this.mg2uUtil)
      .then(async (cont: boolean) => {
        _continueMatchPlay = cont;
        console.debug('check whether comp match', cont, _continueMatchPlay);

        if (_continueMatchPlay) {
          // Not matchplay, check if it's compAllScores (scramble)
          await this.competitionFlowService
            .checkWhetherCompAllScores(competition, false, this.mg2uUtil)
            .then(async (contScramble: boolean) => {
              _continueScramble = contScramble;

              if (_continueScramble) {
                // Not matchplay and not scramble, open normal scoring
                await this.navigateToNormalScoring(_compId);
              }
            });
        }
      });
  }

  private async navigateToNormalScoring(compId: number) {
    let loader = this.loadingCtl.create({
      message: 'Getting scorecard. Please wait...',
      backdropDismiss: false,
      duration: 3000,
    });

    (await loader).present().then(() => {
      this.playerHomeActions.getCompetitionScoring(compId, this.player.playerId, loader);
      let getScorecard = setInterval(() => {
        this.scorecardService.getCurrentScorecard().subscribe((scorecard: PlainScoreCard) => {
          if (scorecard) {
            clearInterval(getScorecard);
            this.competitionService.getCompetitionInfo(compId).subscribe(
              (comp: CompetitionInfo) => {
                this.currentScorecardActions.setScoringPlayer(this.player.playerId);
                let navigationExtras: NavigationExtras = {
                  state: {
                    scorecard: scorecard,
                    competition: comp,
                    currentPlayer: this.player,
                  },
                };
                this.router.navigate(['gameround-scoring'], navigationExtras);
              },
              async error => {
                if (loader) (await loader).dismiss();
              },
              async () => {
                if (loader) (await loader).dismiss();
              }
            );
          }
        });
      }, 500);
    });
  }
}
